// 法语

export default {
  t1: 'Terminer',
  t5: 'Payer',
  t6: 'Lier et autoriser',
}
